export function getContours(grid, threshold) {
    const contours = [];
  
    const rows = grid.length;
    const cols = grid[0].length;
  
    for (let y = 0; y < rows - 1; y++) {
      for (let x = 0; x < cols - 1; x++) {
        const tl = grid[y][x];         // top-left
        const tr = grid[y][x + 1];     // top-right
        const bl = grid[y + 1][x];     // bottom-left
        const br = grid[y + 1][x + 1]; // bottom-right
  
        const squareIndex =
          (tl >= threshold ? 1 : 0) * 8 +
          (tr >= threshold ? 1 : 0) * 4 +
          (br >= threshold ? 1 : 0) * 2 +
          (bl >= threshold ? 1 : 0) * 1;
  
        const edges = edgeTable[squareIndex];
        if (!edges) continue;
  
        for (const [a, b] of edges) {
          contours.push([
            interpolate(x, y, a, grid, threshold),
            interpolate(x, y, b, grid, threshold),
          ]);
        }
      }
    }
  
    return contours;
  }
  
  function interpolate(x, y, edge, grid, threshold) {
    switch (edge) {
      case 'top': {
        const v1 = grid[y][x];
        const v2 = grid[y][x + 1];
        const t = (threshold - v1) / (v2 - v1);
        return [x + t, y];
      }
      case 'right': {
        const v1 = grid[y][x + 1];
        const v2 = grid[y + 1][x + 1];
        const t = (threshold - v1) / (v2 - v1);
        return [x + 1, y + t];
      }
      case 'bottom': {
        const v1 = grid[y + 1][x];
        const v2 = grid[y + 1][x + 1];
        const t = (threshold - v1) / (v2 - v1);
        return [x + t, y + 1];
      }
      case 'left': {
        const v1 = grid[y][x];
        const v2 = grid[y + 1][x];
        const t = (threshold - v1) / (v2 - v1);
        return [x, y + t];
      }
    }
  }
  
  // Marching Squares edge table (case index → list of edge pairs)
  const edgeTable = {
    1: [['bottom', 'left']],
    2: [['right', 'bottom']],
    3: [['right', 'left']],
    4: [['top', 'right']],
    5: [['top', 'left'], ['bottom', 'right']],
    6: [['top', 'bottom']],
    7: [['top', 'left']],
    8: [['left', 'top']],
    9: [['bottom', 'top']],
   10: [['right', 'top'], ['left', 'bottom']],
   11: [['right', 'top']],
   12: [['left', 'right']],
   13: [['bottom', 'right']],
   14: [['left', 'bottom']],
  };